import React, { Component } from 'react';
import { connect } from 'react-redux';
import BasicLayout from '../../components/layout/BasicLayout';
import { Table, Divider, Popconfirm, message, Spin } from 'antd';
import moment from 'moment';
import Department from '../../components/DeparmentsList';
import { withTranslation } from 'react-i18next';
import {
  getRoadwaysApi,
  deleteRoadwayApi,
  searchRoadwayByEventNameApi,
} from '../../services/roadwayService';

class RoadList extends Component {
  constructor() {
    super();
    this.state = {
      loading: true,
      roads: [],
      eventNameDictionary: [],
      workCategoryDictionary: [],
      builderDictionary: [],
      searchText: '',
      pagination: {
        total: 0,
        current: 1,
        pageSize: 10,
        minIndex: 0,
        maxIndex: 10
      }
    };
    this.getData = this.getData.bind(this);
    this.getFilterDictionary = this.getFilterDictionary.bind(this);
  }

  componentDidMount() {
    this.getData();
  }

  handleSearch = (selectedKeys, confirm) => {
    confirm();
    this.setState({ searchText: selectedKeys[0] });
  };

  handleReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: '' });
  };

  async getData() {
    this.setState({ loading: true });
    const userAsJSON = localStorage.getItem('ccAdmin.currentUser');
    const currentUser = userAsJSON ? JSON.parse(userAsJSON) : null;
    const departmentQuery = currentUser ? Department(currentUser) : '';

    try {
      if (departmentQuery) {
        const r = await searchRoadwayByEventNameApi(departmentQuery);
        const roads = (r.data || [])
          .filter((road) => !road.isCross)
          .sort((a, b) => a.id - b.id);
        this.setState(
          (state) => ({
            roads,
            pagination: { ...state.pagination, total: roads.length },
          }),
          () => this.getFilterDictionary()
        );
      } else {
        const result = await getRoadwaysApi(0, 999);
        const content = (result.data && result.data.content) || [];
        const roads = content.filter((road) => !road.isCross);
        this.setState(
          (state) => ({
            roads,
            pagination: {
              ...state.pagination,
              total: (result.data && result.data.totalElements) || roads.length,
            },
          }),
          () => this.getFilterDictionary()
        );
      }
    } catch (e) {
      const { t } = this.props;
      message.error(t('error.network'));
    } finally {
      this.setState({ loading: false });
    }
  }

  getFilterDictionary() {
    const { roads } = this.state;
    const toFilters = (values) =>
      [...new Set(values.filter(Boolean).map((v) => v.trim()))]
        .filter((v) => v !== '')
        .map((v) => ({ text: v, value: v }));
    this.setState({
      eventNameDictionary: toFilters(roads.map((e) => e.eventName)),
      workCategoryDictionary: toFilters(roads.map((e) => e.workCategory)),
      builderDictionary: toFilters(roads.map((e) => e.builder)),
      loading: false,
    });
  }

  goToRoad(record) {
    this.props.history.push('/list/add?id=' + record.id);
  }

  confirmDelete(id) {
    const { t } = this.props;
    deleteRoadwayApi(id)
      .then(() => {
        message.success(t('roadRepairPlan.removed') + ' !');
        this.getData();
      })
      .catch(() => message.error(t('error.network')));
  }

  handleChangeRoadTable = ({ current, pageSize }) => {
    this.setState((state) => ({
      pagination: {
        ...state.pagination,
        current,
        pageSize,
        minIndex: (current - 1) * pageSize,
        maxIndex: current * pageSize
      }
    }));
  }

  render() {
    const { t } = this.props;
    const {
      eventNameDictionary,
      workCategoryDictionary,
      builderDictionary,
      loading,
      roads,
      // pagination,
    } = this.state;

    const columns = [
      {
        title: 'ID',
        dataIndex: 'id',
      },
      {
        title: t('roadRepairPlan.responsible'),
        dataIndex: 'eventName',
        filters: eventNameDictionary,
        onFilter: (value, record) => record.eventName.indexOf(value) === 0,
      },
      {
        title: t('roadRepairPlan.categoryOfWork'),
        dataIndex: 'workCategory',
        filters: workCategoryDictionary,
        onFilter: (value, record) => record.workCategory.indexOf(value) === 0,
      },
      {
        title: t('roadRepairPlan.plot'),
        dataIndex: 'site',
      },
      {
        title: t('roadRepairPlan.street'),
        dataIndex: 'street',
      },
      {
        title: t('roadRepairPlan.contractor'),
        dataIndex: 'builder',
        filters: builderDictionary,
        onFilter: (value, record) => record.builder.indexOf(value) === 0,
      },
      {
        title: t('roadRepairPlan.hiddenWork'),
        dataIndex: 'isHidden',
        render: (text) => <span>{text ? 'Да' : 'Нет'}</span>,
      },
      {
        title: t('roadRepairPlan.start'),
        dataIndex: 'workplanStart',
        render: (text) => (
          <span>{text ? moment(text).format('DD.MM.YYYY') : ''}</span>
        ),
      },
      {
        title: t('roadRepairPlan.end'),
        dataIndex: 'workplanEnd',
        render: (text) => (
          <span>{text ? moment(text).format('DD.MM.YYYY') : ''}</span>
        ),
      },
      {
        title: t('roadRepairPlan.action'),
        key: 'action',
        render: (text, record) => (
          <span>
            <span className="link" onClick={() => this.goToRoad(record)}>
              {t('roadRepairPlan.edit')}
            </span>
            <Divider type="vertical" />
            <Popconfirm
              title={t('roadRepairPlan.exactlyWantToDelete') + '?'}
              onConfirm={() => this.confirmDelete(record.id)}
              onCancel={this.cancel}
              okText={t('roadRepairPlan.yes')}
              cancelText={t('roadRepairPlan.no')}
            >
              <a href="#">{t('roadRepairPlan.delete')}</a>
            </Popconfirm>
          </span>
        ),
      },
    ];

    return (
      <BasicLayout>
        <h3>{t('roadRepairPlan.allRoadRepairPlans')}</h3>
        <Spin
          tip={t('roadRepairPlan.loadingPleaseWait') + '...'}
          spinning={loading}
        >
          <Table
            scroll={{ x: 300 }}
            rowKey={(record) => record.id}
            columns={columns}
            dataSource={roads}
            size="small"
            onChange={this.handleChangeRoadTable}
            // pagination={{
            //   current: pagination.current,
            //   total: pagination.total,
            //   pageSize: pagination.pageSize,
            // }}
          />
          {/* <Modal
            title="Уведомления АРМ Госуслуги"
            open={isModalOpen}
            width={'100%'}
            onCancel={() => {
              setModalOpen(false);
            }}
            footer={false}
          /> */}
        </Spin>
      </BasicLayout>
    );
  }
}
function mapStateToProps(state) {
  const { user } = state;
  return {
    user,
  };
}
export default withTranslation()(connect(mapStateToProps)(RoadList));
